import { render, staticRenderFns } from "./AppCobrowse.vue?vue&type=template&id=b771fa84&"
import script from "./AppCobrowse.vue?vue&type=script&lang=js&"
export * from "./AppCobrowse.vue?vue&type=script&lang=js&"
import style0 from "./AppCobrowse.vue?vue&type=style&index=0&id=b771fa84&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports